module.exports = __webpack_public_path__ + "fonts/mem5YaGs126MiZpBA-UN_r8OUehpOqc.43cb3dce.woff2";